import {CallService} from "./service/api/call.service";
import {ENTITY_SERVICE_REGISTRY} from "../../core/shared/dto/dto-service/entity-service-registry";
import {MvsCrudModeEnum} from "../../core/shared/service/crud/mvs-crud-mode.enum";
import {PcCallComponent} from "./component/protected-components/pc-call/pc-call.component";
import {
    PcCallProtocolComponent
} from "./component/protected-components/pc-call-protocol/pc-call-protocol.component";

export const PC_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['pc.CallType', {route: '/pc/callTypes'}],
            ['pc.Call', {route: '/pc/calls', service: CallService, objectComponent: [{component: PcCallComponent}]}],
            ['pc.CallRecording', {route: '/pc/callRecordings'}],
            ['pc.CallConfiguration', {route: '/pc/callConfigurations'}],
            // pc.CallProtocol is mapped PER MODE, not as an unconditional default.
            //
            // resolveComponentMapping (entity-service-registry.ts:35-66) falls back to the entry with
            // neither mode nor viewType for EVERY mode there is. A default entry therefore also claimed
            // read and delete hosts, which is why the two entries below are spelled out:
            //
            //   create  — REQUIRED, and this is where this mapping differs from the usual pattern:
            //             PcCallProtocolComponent IS the create path. It is mounted without an object
            //             id, takes the call reference out of the default DTO and persists the row
            //             itself. Without this entry the create case would fall through to the generic
            //             form and the immediate save would never happen.
            //   update  — REQUIRED, because after that immediate save every further visit is an edit.
            //
            // read and delete deliberately fall through to the generic CRUD form: the component owns a
            // WRITE flow (immediate persist, the two status actions, an AI dialog session) that has no
            // meaning in a host that only wants to display or delete a protocol.
            //
            // Known consequence, taken deliberately: the QM call-control page
            // (pc-qm-call-control.page.html:18) opens a protocol in the object sidebar WITHOUT an
            // explicit mode, so ObjectComponent#getMode derives update from the present object id and
            // that host keeps getting this component. That is wanted — it is the protocol editor, and
            // its status actions are exactly what call control needs. Its "Zurück" output is simply
            // unhandled there. Cutting that host off would need a viewType scope, not a mode scope, and
            // would take the editor away from it entirely.
            //
            // Round-based LLM dialog — design: projects/pc_call_obc/REQUIREMENT.md §8.3.
            ['pc.CallProtocol', {
                route: '/pc/callProtocols',
                objectComponent: [
                    {mode: MvsCrudModeEnum.create, component: PcCallProtocolComponent},
                    {mode: MvsCrudModeEnum.update, component: PcCallProtocolComponent}
                ]
            }],
            ['pc.CallSaleResultType', {route: '/pc/callSaleResultTypes'}],
        ],
        multi: true
    }
];
